import { render } from "./SelectBoxHeader.vue?vue&type=template&id=338b7770&scoped=true"
import script from "./SelectBoxHeader.vue?vue&type=script&lang=js"
export * from "./SelectBoxHeader.vue?vue&type=script&lang=js"

import "./SelectBoxHeader.vue?vue&type=style&index=0&id=338b7770&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338b7770"]])

export default __exports__